<template>
    <el-dialog
        title="派工程师"
        :visible.sync="engineerDispatchVisible"
        width="90%"
        class="engineerDispatchTable"
        :before-close="closeDialogOnly"
        :close-on-click-modal="false"
    >
        <div class="carryBox" v-loading="loading">
            <div class="concent-right">
                <div class="serach">
                    <el-input type="text" class="orderNo" v-model.trim="orderNo" placeholder="订单号" clearable />
                    <el-button type="primary" @click="searchChange">查 询</el-button>
                </div>
                <el-table
                    class="engineerDispatchTable"
                    ref="engineerDispatchTable"
                    :data="appointmentData"
                    tooltip-effect="dark"
                    border
                    :row-class-name="tableRowClassName"
                    :before-close="closeDialogOnly"
                    @row-click="rowClick"
                    @selection-change="selectionChange"
                    @current-change="handleCurrentChange"
                    highlight-current-row
                    height="270px"
                >
                    <el-table-column type="selection" width="40" v-if="!CNFlag" fixed></el-table-column>
                    <el-table-column prop="orderNo" label="订单号" width="160" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column label="品牌"  prop="brand" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column label="产品品类"  prop="itemClassName" width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column label="产品型号"  prop="itemName" width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column label="送装类型" width="80" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.factInstallTypeName}}</template>
                    </el-table-column>
                    <el-table-column label="配送网点" width="220" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.netTaskAddress.networkName||''}}</template>
                    </el-table-column>
                    <el-table-column label="配送工程师" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.engineerName}}</template>
                    </el-table-column>
                    <el-table-column label="安装网点" width="220" show-overflow-tooltip>
                        <template
                            slot-scope="scope"
                            v-if="scope.row.factInstallType!=='DELIVERYONLY'&&scope.row.orderType!=='DP'"
                        >{{scope.row.netTaskAddress.installNetworkName||''}}</template>
                    </el-table-column>
                    <el-table-column label="安装工程师" width="140" show-overflow-tooltip>
                        <template
                            slot-scope="scope"
                            v-if="scope.row.factInstallType!=='DELIVERYONLY'&&scope.row.orderType!=='DP'"
                        >
                           {{scope.row.installEngineerName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="netDispatchRemark" label="备注" width="200" show-overflow-tooltip></el-table-column>
                </el-table>
                <el-pagination
                    class="table-paginations"
                    @size-change="handleSizeChange"
                    @current-change="CurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100,200]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="pageTotal"
                ></el-pagination>
            </div>
            <div class="concent-left">
                <div class="base-info">
                    <el-form label-position="right" label-width="100px" :model="currentRowData">
                            <template v-if="currentRowData && currentRowData.orderType && currentRowData.orderType === 'RI'">
                                <el-form-item label="用 户："><span>{{currentRowData.netTaskAddress.senderName||currentRowData.senderName}}</span></el-form-item>
                                <el-form-item label="电 话："><span>{{currentRowData.netTaskAddress.senderMobile||currentRowData.senderMobile}}</span></el-form-item>
                                <el-form-item label="地 址："><span>{{currentRowData.netTaskAddresssenderProvinceName||'-'}} /
                            {{currentRowData.netTaskAddress.senderCityName||'-'}} /
                            {{currentRowData.netTaskAddress.senderDistrictName||'-'}} /
                            {{currentRowData.netTaskAddress.senderTownName||'-'}}
                            {{currentRowData.netTaskAddress.senderDetailAddr}}</span></el-form-item>
                            </template>
                            <template v-else-if="currentRowData && currentRowData.orderType && currentRowData.orderType !== 'RI'">
                                <el-form-item label="用 户："><span>{{currentRowData.netTaskAddress.receiverName||currentRowData.receiverName}}</span></el-form-item>
                                <el-form-item label="电 话："><span>{{currentRowData.netTaskAddress.receiverMobile||currentRowData.receiverMobile}}</span></el-form-item>
                                <el-form-item label="地 址："><span>{{currentRowData.netTaskAddress.receiverProvinceName||'-'}} /
                            {{currentRowData.netTaskAddress.receiverCityName||'-'}} /
                            {{currentRowData.netTaskAddress.receiverDistrictName||'-'}} /
                            {{currentRowData.netTaskAddress.receiverTownName||'-'}}
                            {{currentRowData.netTaskAddress.receiverDetailAddr}}</span></el-form-item>
                            </template>
                    </el-form>
                </div>
                <div class="appoint-edit-info">
                    <el-form label-position="right"  :rules="rules" label-width="100px" ref="engineerForm" :model="appointData">
                          <el-form-item
                                label="配送工程师"
                                prop="engineerNo"
                            >
                                <el-select
                                    v-model="appointData.engineerNo"
                                    placeholder="请选择"
                                    @change="dvlEgnChange(appointData.engineerNo)"
                                    filterable
                                    clearable
                                >
                                    <el-option
                                        v-for="(item, index) in optionList"
                                        :key="index"
                                        :value="item.engineerNo"
                                        :label="item.engineerName"
                                    >
                                        <span class="optLeft">{{ item.engineerName }}</span>
                                        <span class="optRight">{{ item.engineerNo }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                          <el-form-item
                                label="安装工程师"
                                prop="installEngineerNo"
                            >
                                <el-select
                                    v-model="appointData.installEngineerNo"
                                    placeholder="请选择"
                                    @change="setEgnChange(appointData.installEngineerNo)"
                                    filterable
                                    clearable
                                >
                                    <el-option
                                        v-for="(item, index) in optionList"
                                        :key="index"
                                        :value="item.engineerNo"
                                        :label="item.engineerName"
                                    >
                                        <span class="optLeft">{{ item.engineerName }}</span>
                                        <span class="optRight">{{ item.engineerNo }}</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="备注">
                                <el-input type="text" v-model="appointData.netDispatchRemark" clearable />
                            </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogOnly">取 消</el-button>
            <el-button type="primary" @click="saveAppointment">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import api from '../../../../api/netTaskManage2c.js';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    name: 'engineerDispatchDialog',
    components: {},
    data() {
        return {
            loading: false,
            CNFlag: false,
            appointEngineer: 0,
            engineerDispatchVisible: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                }
            },
            rules: {
                engineerNo: {
                    required: true,
                    message: '必须填写配送工程师',
                    trigger: 'blur'
                }
            },
            appointmentData: [],
            currentRowData: {},
            selectedData: [],
            orderList: [],
            appointData: {
                engineerNo: '',
                engineerName: '',
                engineerMobile: '',
                installEngineerNo: '',
                installEngineerName: '',
                installEngineerMobile: '',
                netDispatchRemark: ''
            },
            orderNo: '',
            optionList: [],
            srmException: {},
            pageSize: 100,
            currentPage: 1,
            pageTotal: 0,
            searparams: {}
        };
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val;
            this.getDate(this.searparams);
        },
        CurrentChange(val) {
            this.currentPage = val;
            this.getDate(this.searparams);
        },
        tableRowClassName({ row }) {
            if (
                this.selectedData &&
                this.selectedData.map((item) => item.orderNo).includes(row.orderNo)
            ) {
                return 'highlight-row';
            }
        },
        async show(data, CNFlag) {
            this.data = data;
            this.CNFlag = CNFlag || false;
            this.getDate();
        },
        async  getDate(searchParams) {
            this.loading = true;
            const dictData = await dictWithUrl('INSTALL_TYPE');
            const installType = dictData.data.INSTALL_TYPE;
            const data = this.data;
            let dispatchList = data;
            let currentInx;
            if (this.CNFlag) {
                // 菜鸟2B订单模式：需同一客户订单下所有订单预约完成后，才可以派工
                this.CNFlag = true;
                dispatchList = [data];
                const params = {
                    sourceSystem: 'CAINIAO',
                    businessMode: 'B2B',
                    orderType: 'PO',
                    receiverMobile: data.receiverMobile || data.netTaskAddress.receiverMobile,
                    customerOrderNo: data.customerOrderNo,
                    orderStatusList: ['120', '130', '140', '145'],
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    ...searchParams
                };
                let count = 0;
                let totalQty = 0;
                await api.getLists(params).then(res => {
                    if (res && res.code === '0' && res.data.list.length) {
                        res.data.list.map((item, idx) => {
                            item.netTaskItems.forEach(items => {
                                count += items.netRealReceive;
                            });
                            totalQty = item.customerTotalQty;
                            if (item.orderNo === data.orderNo) {
                                currentInx = idx.toString();
                            }
                        });
                        if (currentInx) res.data.list.unshift(res.data.list.splice(currentInx, 1)[0]);
                        dispatchList = res.data.list;
                    }
                }).catch(() => {});
                api.getListCount(params).then(res => {
                    if (res && res.code === '0') {
                        this.pageTotal = res.data;
                    }
                }).catch(() => {});
                if (count !== totalQty) {
                    this.$message.warning('天猫优品同一客户订单号需要全部预约后，才能派工');
                    this.closeDialogOnly();
                    return;
                };
            } else {
                const params = {
                    receiverMobile: data.receiverMobile || data.netTaskAddress.receiverMobile,
                    networkCode: data.networkCode,
                    orderStatusList: ['120', '130', '140', '145'],
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    ...searchParams
                };
                await api.getLists(params).then(res => {
                    if (res && res.code === '0' && res.data.list.length) {
                        res.data.list.map((item, idx) => {
                            if (item.orderNo === data.orderNo) {
                                currentInx = idx.toString();
                            }
                        });
                        if (currentInx) res.data.list.unshift(res.data.list.splice(currentInx, 1)[0]);
                        dispatchList = res.data.list;
                    }
                }).catch(() => {});
                api.getListCount(params).then(res => {
                    if (res && res.code === '0') {
                        this.pageTotal = res.data;
                    }
                }).catch(() => {});
            }
            this.appointmentData = _.cloneDeep(dispatchList);
            this.engineerDispatchVisible = true;
            // 抽取网点
            this.orderList = [];
            this.appointmentData.forEach((item) => {
                this.orderList.push(item.orderNo);
                item.factInstallTypeName = item.factInstallTypeName || installType[item.factInstallType];
            });
            // 获取工程师
            const errorList = [];
            api.getEngineers({ orderNos: this.orderList }).then(res => {
                if (res && res.code === '0') {
                    res.data.forEach(item => {
                        if (item.engineer && item.engineer.length) {
                            this.optionList = item.engineer;
                        } else {
                            errorList.push(item.orderNo);
                        }
                    });
                    if (errorList.length) {
                        this.$message.warning('获取工程师失败');
                    }
                }
            });
            await api.getEngineersError({ orderNos: this.orderList }).then(res => {
                if (res && res.code === '0') {
                    res.data.forEach(item => {
                        if (item.srmException || item.tryCalculateException) {
                            this.srmException[item.orderNo] = item.srmExceptionMsg || item.tryCalculateExceptionMsg;
                        }
                    });
                }
            });
            this.$nextTick(() => {
                if (this.CNFlag) {
                    this.$refs.engineerDispatchTable.toggleAllSelection();
                } else {
                    this.$refs.engineerDispatchTable.toggleRowSelection(this.appointmentData[0]);
                }
                this.$refs.engineerDispatchTable.setCurrentRow(this.appointmentData[0]);
                this.$refs.engineerDispatchTable.doLayout();
                this.loading = false;
            });
        },
        searchChange() {
            this.searparams = {
                orderNo: this.orderNo || ''
            };
            this.getDate(this.searparams);
        },
        // 配送工程师修改
        dvlEgnChange(engineerNo) {
            this.optionList.forEach(item => {
                if (item.engineerNo === engineerNo) {
                    this.appointData.engineerName = item.engineerName;
                    this.appointData.engineerMobile = item.engineerMobile;
                }
            });
            this.selectedData.forEach(item => {
                this.$set(item, 'engineerNo', this.appointData.engineerNo);
                this.$set(item, 'engineerName', this.appointData.engineerName);
                this.$set(item, 'engineerMobile', this.appointData.engineerMobile);
                // 安装来源'OTP'的订单，自动填充安装工程师
                if (item.installOrderSource === 'OTP' && item.netTaskAddress.installNetworkCode) {
                    this.$set(item, 'installEngineerNo', this.appointData.engineerNo);
                    this.$set(item, 'installEngineerName', this.appointData.engineerName);
                    this.$set(item, 'installEngineerMobile', this.appointData.engineerMobile);
                }
            });
        },
        // 安装工程师修改
        setEgnChange(installEngineerNo) {
            this.optionList.forEach(item => {
                if (item.engineerNo === installEngineerNo) {
                    this.appointData.installEngineerName = item.engineerName;
                    this.appointData.installEngineerMobile = item.engineerMobile;
                }
            });
            this.selectedData.forEach(item => {
                this.$set(item, 'installEngineerNo', this.appointData.installEngineerNo);
                this.$set(item, 'installEngineerName', this.appointData.installEngineerName);
                this.$set(item, 'installEngineerMobile', this.appointData.installEngineerMobile);
                // 安装来源'OTP'的订单，自动填充配送工程师
                if (item.installOrderSource === 'OTP' && item.netTaskAddress.installNetworkCode) {
                    this.$set(item, 'engineerNo', this.appointData.installEngineerNo);
                    this.$set(item, 'engineerName', this.appointData.installEngineerName);
                    this.$set(item, 'engineerMobile', this.appointData.installEngineerMobile);
                }
            });
        },
        rowClick(row) {
            this.$refs.engineerDispatchTable.toggleRowSelection(row, true);
        },
        selectionChange(data) {
            this.selectedData = data;
        },
        handleCurrentChange(currentRow, oldCurrentRow) {
            this.currentRowData = currentRow;
        },
        async saveAppointment() {
            if (!this.selectedData.length) {
                return this.$message.warning('请选择需派工订单');
            }
            let flag = true;
            const list = [];
            let count = 0;
            await this.$refs.engineerForm
                .validate()
                .then(async(value) => {
                    flag = true;
                    // 菜鸟项目默认全部提交
                    await this.selectedData.forEach((item, idx) => {
                        const data = {
                            // 15：全修改
                            type: 15,
                            orderNo: item.orderNo,
                            orderType: item.orderType,
                            factInstallType: item.factInstallType,
                            netDispatchRemark: item.netDispatchRemark,
                            engineerNo: item.engineerNo || '',
                            engineerName: item.engineerName || '',
                            engineerMobile: item.engineerMobile || '',
                            installEngineerNo: item.installEngineerNo || '',
                            installEngineerName: item.installEngineerName || '',
                            installEngineerMobile: item.installEngineerMobile || ''
                        };
                        if (
                            item.engineerNo && !item.installEngineerNo
                        ) {
                            // 11：派送工程师修改
                            data.type = 11;
                        } else if (
                            !item.engineerNo && item.installEngineerNo
                        ) {
                            // 13：安装工程师修改
                            data.type = 13;
                        }
                        list.push(data);
                        if (item.factInstallType === 'INTEGRATE' && (item.netTaskAddress.networkCode === item.netTaskAddress.installNetworkCode) && !item.installEngineerNo) {
                            count++;
                        }
                    });
                    if (count) {
                        flag = false;
                        this.$message.warning('送装一体订单，安装工程师必填！');
                    }
                    if (!list.length) {
                        flag = false;
                        this.$message.warning('改派没有任何修改，请检查');
                    }
                })
                .catch(() => {
                    flag = false;
                    this.$message.warning('请检查必填项');
                });
            if (!flag) return;
            for (let i = 0; i < this.selectedData.length; i++) {
                if (this.srmException[this.selectedData[i].orderNo]) {
                    return this.$message.warning(`订单号:${this.selectedData[i].orderNo},${this.srmException[this.selectedData[i].orderNo]}`);
                }
            }
            this.loading = true;
            await api.saveEngineers(list).then((res) => {
                if (res && res.code === '0') {
                    this.$message.success('操作成功');
                }
            })
                .catch(() => {});
            this.loading = false;
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'engineerDispatchDialog', false);
        },
        closeAndRefresh() {
            this.$emit('closeDialog', 'engineerDispatchDialog', true);
        }
    }
};
</script>

<style lang="less">
.engineerDispatchTable {
     min-width: 800px;
     .orderNo{
         margin-right: 10px;
         width: 200px;
     }
    .carryBox{
        display: flex;
        .concent-left{
            width: 350px;
            border-left: 1px solid #e6e6e6;
            margin-left: 10px;
            padding-left: 10px;
        }
        .concent-right{
            flex: 1;
            overflow: auto;
        }
        .serach{
            margin: 5px 0px;
        }
    }
    .base-info {
            border-bottom: 1px solid #e6e6e6;
            margin-bottom: 10px;
            padding-bottom: 5px;
            .el-form-item {
                margin-bottom: 0px;
            }
            .el-form-item__label,.el-form-item__content{
                line-height: 25px;
            }
    }
    .engineerDispatchTable {
        .el-form-item__content {
            line-height: 0px;
        }
        .el-table__body tr.current-row > td {
        background-color: #b2deec;
        color: #c56183;
        }
        .cell {
            height: 28px;
            line-height: 28px;
            font-size: 10px;
            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 100%;
            }
        }
    }
    .el-select{
        width: 100%;
    }
    .el-table__body tr.highlight-row {
        background: #e6f8f9;
     }
     .el-dialog__body{
         padding-top: 5px;
     }
    .el-dialog__footer{
        margin-bottom: 5px;
        padding: 0px 20px 10px;
    }
   .table-paginations{
        margin: 10px 0px;
        float: right;
        padding: 0;
        .btn-prev, .btn-next, .el-pager li {
            background-color: #ffffff !important;
            border: 1px solid #cccccc;
            border-radius: 4px !important;
            padding:0;
            min-width: 30px;
            margin-right:4px;
        }
        .el-pager li.active + li {
            border-left: 1px solid #cccccc;
        }
        .el-pager li:not(.disabled).active {
            background-color: #00BCBF !important;
            border: 1px solid #00BCBF;
            color:#ffffff !important;
        }
    }
}
</style>